import React from 'react';
import { useSelector } from 'react-redux';
import { CharacterModel } from '../../interfaces/character.interface';
import { RootState } from '../../store/store';
import { SecureImg } from '../Common/SecureImage';

interface AdminCharacterGridProps {
  characters: CharacterModel[];
}

const AdminCharacterGrid: React.FC<AdminCharacterGridProps> = ({ characters }) => {
  const artStyleById = useSelector((state: RootState) => state.app.artStyleById);

  if (!characters || characters.length === 0) {
    return <div className="text-center text-gray-500 py-8">No characters found for this user.</div>;
  }

  return (
    <div className="w-full rounded-md flex justify-center overflow-y-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
        {characters.map((character, index) => {
          const artStyleLabel =
            (character?.artStyle && artStyleById?.[character.artStyle]) ||
            character?.artStyle?.split(/[-_]/)?.join(' ') ||
            '—';
          return (
            <div
              key={character.characterId || index}
              className="p-2 book-item font-sans text-storyblue bg-storytan max-w-[19rem] rounded-md mx-auto mb-2 w-full"
            >
              <div className="flex justify-center bg-gray-100 rounded-md">
                <SecureImg
                  storageSrc={character?.characterUrl}
                  alt={`${character?.characterName || 'Character'} portrait`}
                  className="h-[18rem] w-[18rem] object-contain rounded-md shadow-xl mb-2"
                />
              </div>
              <p className="text-sm capitalize mt-2">
                <strong>Name:</strong> {character?.characterName || '—'}
              </p>
              <p className="text-sm capitalize">
                <strong>Art style:</strong> {artStyleLabel}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminCharacterGrid;
